import { useState, useEffect } from 'react';

/**
 * Hook to detect if we're running on the client side.
 * Returns false during SSR and initial hydration, true after mount.
 */
export function useIsClient(): boolean {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
